module.exports = "/_next/static/media/Video1.0aed1024f42163d117f7ca8444c4a278.mp4";